export default __webpack_public_path__ + "static/media/open-in-new.e4f9c2fc.svg";